import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buffer-loader',
  templateUrl: './buffer-loader.component.html',
  styleUrls: ['./buffer-loader.component.scss']
})
export class BufferLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
